import React, { useEffect, useState } from 'react';
//import { armonizacionContable } from '../../json/armonizacionContable';
import '../DetalleArmonizacionContable/detalleArmonizacionContable.css';

  const DetalleArmonizacionContable2024 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Armonización Contable 2024</h2>
            <hr className='hr-gob'/>
          </div>

            <div style={{ width: "100%" }}>
                <table className="table table-striped table-bordered">
                          <tr>
                            <th scope="col"><div className="detalle_nombreDocumentoAC" style={{ width: "520px" }}>Documento</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>1er_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>2do_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>3er_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>4to_Trim</div></th>
                          </tr>
                </table>
            </div>

            <div className="tabla-contenedorAC">
            <table className="table table-striped table-bordered tabla-elementosAC">
                    <tbody>
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Contable</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Activo</div></th>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/2doTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>   
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Resultados/Actividades</div></th>
                        <td>
                            <div>
                               <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                               <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/2doTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Flujos de Efectivo</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/2doTrim/Estado_de_Flujo_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_de_Flujo_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Cambios en la Situación Financiera</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>    
                        </tr>
                        
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Situación Financiera</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/2doTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Variación en la Hacienda Pública</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/2doTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                               <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>   
                        </tr>      
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos</div></th>
                          <td>
                            <div>
                               <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer">
                               <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>  
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Informe de Pasivos Contingentes</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/Informe_de_Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/Informe_de_Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Notas a los Estados Financieros</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/NotasalosEstadosFinancieros.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/2doTrim/Notas_a_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/Notas_a_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Notas_a_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>  
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Manual de Contabilidad</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/MANUAL_DE_CONTABILIDAD_2024_SISTEMA_DIFH.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/2doTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/4toTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>  
                        </tr>
                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Presupuestaria</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ingreso, clasificación económica por fuente de financiamiento y concepto</div></th>
                       <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                            <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                            <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos, (Administrativa)</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/2Estado_Analitico_por_Clasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_Analitico_del_Presupuesto_de_Egresos_Clasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación Económica por tipo de Gasto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/3EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/3Estado_Analitico_por_Clasificacion_Economica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/3EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_Analitico_del_Presupuesto_de_Egresos_Clasificacion_Economica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación por objeto del gasto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/4Estado_Analitico_por_Objeto_del_Gasto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_Analitico_del_Presupuesto_de_Egresos_Clasificacion_por_Objeto_del_Gasto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación Funcional</div></th>
                        <td>
                          <div>
                           <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/5Estado_Analitico_por_Clasificacion_Funcional.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                           <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Estado_Analitico_del_Presupuesto_de_Egresos_Clasificacion_Funcional.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Endeudamiento Neto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/6Endeudamiento_Neto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                        <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/6EndeudamientoNeto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>   
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Intereses de la Deuda</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/7InteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/7Intereses_de_la_Deuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/7InteresesdelaDeuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/7Intereses_de_la_Deuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Flujo de Fondos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/8Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div> 
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/8Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/8Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/8Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                     
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Programática</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Gasto por Categoría Programática</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/9GastoporCategoriaProgramatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/9Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/9Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div>
                             <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td> 
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Indicadores de Resultados</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/IR_SIIPPED_1erTRIM_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                             <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/IR_2doTRIM_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                             <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/IR_3erTRIM_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                             <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/IR-4TO-TRIM2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td> 
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Programas y Proyectos de Inversión</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/3erTrim/10Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2024/4toTrim/10Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>   
                        </td>  
                      </tr> 

              
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Inventarios</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Inventario de Bienes Muebles</div></th>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/RBMI_DIF_1ER_TRIM_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>   
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/RELACION_DE_BIENES_MUEBLES_2DO_TRIM_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>   
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/RBMI_DIF_03_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>  
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/RBMI_DIF_4_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>  
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Inventario de Bienes Inmuebles</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/IBIM_DIF_01_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>  
                        </td>
                        <td>
                         <div>
                             <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/IBIM_DIF_02_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>  
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/Inventario_de_Bienes-Inmuebles-3erTrim2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>  
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/Inventario_de_Bienes_Inmuebles-4toTrim2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>  
                        </td>
                      </tr>

                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Adicional</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información para la Difusión de la Ley de Ingresos y del Presupuesto de Egresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Informacion_para_la_Difusion_de_la_Ley_de_Ingresos_y_del_Presupuesto_de_Egresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información del Calendario de Ingresos base mensual</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Estructura_del_Calendario_de_Ingresos_base_mensual_NOR_01_14_004.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información del Calendario de Egresos base mensual</div></th>
                        <td>
                         <div>
                           <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Calendario_del_presupuesto_de_Egresos_del_ejercicio_fiscal_NOR_01_14_005.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información Adicional a la Iniciativa de la Ley de Ingresos</div></th>
                        <td>
                        <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/a_Informacion_adicional_a_la_iniciativa_de_la_Ley_de_Ingreos_NOR_01_14_001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información Adicional al Proyecto de Presupuesto de Egresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Informacion_adicional_al_proyecto_del_Presupuesto_de_Egresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Calendario de Programación Presupuestal</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Calendario_del_Gasto_1Trim_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>  
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Normas</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Montos Pagados por Ayudas y Subsidios</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/1erTrim/Ayudas_y_subdisios_1er_Trim_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/2doTrim/Formato_MPAS_2DO_TRIMESTRE_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/3erTrim/Formato_MPAS_3er_TRIM_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2024/4toTrim/Formato_MPAS_4To_TRIMESTRE_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>  
                      </tr>
                    </tbody>
              </table>
            </div>


          </div>
      </div>



//
//
//  <div className="contenedor-tablaLDF">
//                {
//                  armonizacionContable.map((item, index)=>(
//                     
//                              <div className="th-seccion" key={index}> {item.seccion} </div>
//                          
//                            {
//                                item.documentos.map((doc, n)=>(
//                                 <div key={ n }>
//                                      
//                                        <div className="detalle_iLDF"><i className="fas fa-file-pdf"></i></div>
//                                      
//                                        <div className="detalle_documentoLDF"> {doc.documentoItem} </div>
//                                      
//                                         {
//                                            doc.trimestres.map((trim, x)=>(
//                                                  
//                                                    <div className="div-elementosLDF" key={x}>
//                                                        <a href={ trim.link1erTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                                  
//                                                    <div className="div-elementosLDF" key={ x }>
//                                                        <a href={ trim.link2doTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                                  
//                                                    <div className="div-elementosLDF" key={ x }>
//                                                        <a href={ trim.link3erTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                                  
//                                                    <div className="div-elementosLDF" key={ x }>
//                                                        <a href={ trim.link4toTrim } target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-pdf" type="button">PDF</button></a>
//                                                    </div>
//                                                  
//                                            ))
//                                          } 
//                                  </div>
//                              ))
//                           } 
//                  ))
//                }  
//          </div>         
//       </div>
//      </div>
//    )

 //   }  

    
  )
}


  export default DetalleArmonizacionContable2024